'use strict'

import master from 'Modules/master'
import rollingTexts from 'Modules/rollingTexts'

// TODO
// Refacto layout
master.process()
rollingTexts.init()
